// extracted by mini-css-extract-plugin
export default {"search_input_wrapper":"SearchBar_search_input_wrapper__RHTmG","search_input":"SearchBar_search_input__1Iqk0","input_icon":"SearchBar_input_icon__6pmdW"};